import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AdminBalancePopup from "../common/AdminBalancePopup";

const Navigation = () => {
  const nav = useNavigate();
  const location = useLocation();

  const [showAdminPopup, setShowAdminPopup] = useState(false);
  const logoutTimer = useRef(null);

  const toggleSidebar = () => {
    document.documentElement.classList.toggle("layout-menu-expanded");
    document.querySelector(".layout-menu")?.classList.toggle("collapsed");
  };

  useEffect(() => {
    if (window.innerWidth < 1200) {
      document.documentElement.classList.remove("layout-menu-expanded");
      document.querySelector(".layout-menu")?.classList.add("collapsed");
    }
  }, [location.pathname]);

  const logout = () => {
    localStorage.clear();
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0];
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
    nav("/login");
  };

  const startLogoutTimer = () => {
    logoutTimer.current = setTimeout(logout, 3 * 60 * 60 * 1000);
  };

  const resetLogoutTimer = () => {
    clearTimeout(logoutTimer.current);
    startLogoutTimer();
  };

  useEffect(() => {
    startLogoutTimer();
    window.addEventListener("mousemove", resetLogoutTimer);
    window.addEventListener("keypress", resetLogoutTimer);

    return () => {
      clearTimeout(logoutTimer.current);
      window.removeEventListener("mousemove", resetLogoutTimer);
      window.removeEventListener("keypress", resetLogoutTimer);
    };
  }, []);

  const user_name = `${localStorage.getItem("first_name")} ${localStorage.getItem("last_name")}`;

  return (
    <>
      <nav
        className="layout-navbar container-fluid navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
        id="layout-navbar"
      >
        <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 d-xl-none">
          <button className="nav-item nav-link px-0" onClick={toggleSidebar}>
            <i className="ti ti-menu-2 ti-sm"></i>
          </button>
        </div>

        <div className="navbar-nav-right d-flex align-items-center flex-grow-1">
          <ul className="navbar-nav flex-row align-items-center ms-auto">

            <li className="nav-item me-3">
              <button
                className="nav-link btn p-0 d-flex align-items-center"
                onClick={() => setShowAdminPopup(true)}
                title="Admin Balance"
              >
                <i className="ti ti-wallet" style={{ fontSize: "30px" }}></i>
              </button>
            </li>

            <li className="nav-item navbar-dropdown dropdown-user">
              <Link
                className="nav-link dropdown-toggle hide-arrow"
                to="#"
                data-bs-toggle="dropdown"
              >
                <div className="avatar avatar-online">
                  <img
                    src="../../assets/img/avatars/1.png"
                    alt="avatar"
                    className="h-auto rounded-circle"
                  />
                </div>
              </Link>

              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <Link className="dropdown-item" to="#">
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar avatar-online">
                          <img
                            src="../../assets/img/avatars/1.png"
                            alt="avatar"
                            className="h-auto rounded-circle"
                          />
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <span className="fw-medium d-block">{user_name}</span>
                        <small className="text-muted">Admin</small>
                      </div>
                    </div>
                  </Link>
                </li>

                <li><div className="dropdown-divider"></div></li>

                <li>
                  <Link className="dropdown-item" to="/change-password">
                    <i className="ti ti-user-check me-2 ti-sm"></i>
                    Change Password
                  </Link>
                </li>

                <li>
                  <button className="dropdown-item" onClick={logout}>
                    <i className="ti ti-logout me-2 ti-sm"></i>
                    Log Out
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>

      {showAdminPopup && (
        <AdminBalancePopup onClose={() => setShowAdminPopup(false)} />
      )}
    </>
  );
};
export default Navigation;